import { orderStatus } from '@/constants';
import { orderPushService } from '@/lib/map-control/orderPushService';
// 주문 푸시 이벤트 메서드 맵퍼
// 푸시 이벤트 흐름
// WebSocketMapControl -> MapWrapper.vue -> handlePushOrder.ts -> actionNormalOrder -> orderPushMethods -> orderPushService
export const orderPushMethods = {
    /**
     * 대기 -> 제거
     */
    [orderStatus.WAITED.code](orderData) {
        orderPushService.deleteOrder(orderData);
    },
    /**
     * 대기 취소 -> 접수 상태 돼야 함
     */
    [orderStatus.WAIT_END.code](orderData) {
        orderPushService.mergeStatusAccepted(orderData);
    },
    /**
     * 배차 요청 거절 (라이더가 배차 요청을 거절함)
     */
    [orderStatus.ALLOCATE_REJECTED.code](orderData, _isShareOrder) {
        orderPushService.allocateCancel(orderData, _isShareOrder);
    },
    /**
     * 자체 배달 -> 제거
     * 상점에서 자체 배달하기에 지도관제에서 노출될 필요 x
     */
    [orderStatus.SELF_DELIVERY.code](orderData) {
        orderPushService.deleteOrder(orderData);
    },
    /**
     * 예약 -> 제거
     */
    [orderStatus.RESERVED.code](orderData) {
        orderPushService.deleteOrder(orderData);
    },
    /**
     * 예약 취소 -> 접수 상태 돼야 함
     */
    [orderStatus.RESERVE_END.code](orderData) {
        orderPushService.mergeStatusAccepted(orderData);
    },
    /*
     * 접수 됨 -> 접수 상태 돼야 함
     */
    [orderStatus.ACCEPTED.code](orderData) {
        orderPushService.mergeOrder(orderData);
    },
    /**
     * 재접수 -> 접수 상태 돼야 함
     */
    [orderStatus.RE_ACCEPT.code](orderData) {
        orderPushService.mergeStatusAccepted(orderData);
    },
    /**
     * 배차 요청 함 -> 주문 객체 업데이트
     */
    [orderStatus.WORKER_REQUESTED.code](orderData) {
        orderPushService.mergeOrder(orderData);
    },
    /**
     * 배차 됨 -> 배차 상태 돼야 함.
     */
    [orderStatus.ALLOCATED.code](_orderData = {}) {
        orderPushService.mergeStatusAllocated(_orderData);
        // const orderData = new Order(_orderData);
        // 내가 배차한게 아닌걸 알 필요가 있나?
        // 내가 배차한 것은 api 응답으로 알 수 있다.
        // 다른 곳에서 한 것도 알아야 한다면 필요. 그렇지 않다면 필요 x.
        // 배차결과 팝업에 대한 일괄 정리 필요 20240820
        // const {
        //   orderId,
        //   preStatusCode,
        //   storeName,
        //   allocatedWorkerName: workerName,
        //   orderAgencyId,
        //   orderAgencyOptions,
        // } = orderData;
        // const subscribeKey = getters['hubSelector/getterIsSubscribeHub']
        //   ? 'allocatedHubId'
        //   : 'allocatedDistributorId';
        // const selectedHubId = hubSelector.subscribeHubInfo[0].id;
        // const isMyWorker = orderData[subscribeKey] === selectedHubId;
        // if (
        //   orderAgencyId
        //   && preStatusCode === orderStatus.WORKER_REQUESTED.code
        //   && isMyWorker
        // ) {
        //   dispatch(allocationAlertActionType.print, [
        //     {
        //       isSuccess: true,
        //       title: i18n.t(`${lc}${ getTitle('accept', allocateWorkerType.REQUEST_ALLOCATE)}`),
        //       storeName,
        //       workerName,
        //       orderId,
        //       // 백엔드 부하 테스트 중이라 orderAgencyOptions에 값이 없을 수 있음, 이때는 domain model에서 상위 dep allocateLimit/serviceLevelAgreementDeliveryTime 사용하도록 함
        //       message: getMessage('REQUEST_ACCEPT', {
        //         allocateLimit: orderAgencyOptions!.allocateLimit!,
        //         serviceLevelAgreementDeliveryTime:
        //         orderAgencyOptions?.serviceLevelAgreementDeliveryTime!
        //         ,
        //       }),
        //     },
        //   ]);
        // }
    },
    /**
     * 즉시 배차 -> 배차 상태 돼야 함.
     */
    [orderStatus.IMMEDIATE_ALLOCATE.code](orderData) {
        orderPushService.mergeStatusAllocated(orderData);
    },
    /**
     * 픽업 도착
     */
    [orderStatus.PICKUP_ARRIVED.code](orderData) {
        orderPushService.mergeOrder(orderData);
    },
    /**
     * 픽업 완료 -> 픽업
     */
    [orderStatus.PICKUP_FINISHED.code](orderData) {
        orderPushService.pickUp(orderData);
    },
    /**
     * 배달 완료 -> 제거
     */
    [orderStatus.DROP_FINISHED.code](orderData) {
        orderPushService.deleteOrder(orderData);
    },
    /**
     * 주문 취소 -> 제거
     */
    [orderStatus.CANCELED.code](pushOrderData) {
        orderPushService.deleteOrder(pushOrderData);
    },
    /**
     * 주문 정보 변경 -> 주문 객체 업데이트
     * @param Object
     */
    [orderStatus.ORDER_MODIFY.code](pushData) {
        orderPushService.orderModify(pushData);
    },
    /**
     * TODO 명확한 케이스 확인 필요 tg0825 20231106
     * 배차 요청 취소 (배차 요청을 한 쪽에서 취소함) -> 접수
     */
    [orderStatus.WORKER_REQUESTED_CANCEL.code](orderData) {
        orderPushService.workerRequestedCancel(orderData);
    },
    /**
     * 배차 취소 -> 접수 상태 돼야 함
     * 허브장이 배차취소를 할 경우
     * 라이더가 스스로 배차를 취소할 경우에도 사용 됐으나 현재는 해당 상황은 worker_rejected가 대응함. 즉 허브장이 배차취소할 경우에만 해당 함 tg0825 20240103
     */
    [orderStatus.ALLOCATE_CANCEL.code](pushData, _isShareOrder) {
        orderPushService.allocateCancel(pushData, _isShareOrder);
    },
};
